import { ColumnFiltersState } from '@tanstack/react-table';
import { Dispatch, SetStateAction, useMemo, useCallback } from 'react';

import { FilterState } from './types';

export function useTableFilterState(
  filterState: FilterState,
  onChangeFilterState: Dispatch<SetStateAction<FilterState>>
) {
  const tableFilterState = useMemo(
    () => [
      ...(filterState.usernames
        ? [{ id: 'username', value: filterState.usernames }]
        : []),
      ...(filterState.contexts
        ? [{ id: 'context', value: filterState.contexts }]
        : []),
    ],
    [filterState]
  );

  const handleChangeFilters = useCallback(
    (newFilters: ColumnFiltersState) => {
      onChangeFilterState((filterState) => ({
        ...filterState,
        usernames:
          (newFilters.find((f) => f.id === 'username')
            ?.value as Array<string>) || [],
        contexts:
          (newFilters.find((f) => f.id === 'context')
            ?.value as Array<string>) || [],
      }));
    },
    [onChangeFilterState]
  );
  return { tableFilterState, handleChangeFilters };
}
